import useCaseList from "../../features/cases/useCaseList";
import CaseListDesktop from "../cases/CaseListDesktop";
import { OUTSOLON_CONFIG } from "./outsolonConfig";

const LIST = { endpoint: "/outsolon" };

const OutSolonDesktop = () => (
  <CaseListDesktop config={OUTSOLON_CONFIG} list={useCaseList(LIST)} />
);

export default OutSolonDesktop;
